module.exports = __webpack_public_path__ + "officialStatic/img/productB36.e8d14e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/productB36.png
// module id = gg0v
// module chunks = 0